import { Tolgee, DevTools, FormatSimple } from '@tolgee/react';

const tolgeeInstance = Tolgee().use(FormatSimple());

if (import.meta.env.DEV) {
  tolgeeInstance.use(DevTools());
}

export const tolgee = tolgeeInstance.init({
  language: 'pl-PL',
  fallbackLanguage: 'pl-PL',
  apiUrl: import.meta.env.DEV ? (import.meta.env.VITE_TOLGEE_API_URL || 'http://localhost:8085') : undefined,
  apiKey: import.meta.env.DEV ? import.meta.env.VITE_TOLGEE_API_KEY : undefined,
  staticData: {
    'pl-PL': () => import('./locales/pl.json'),
    'pl': () => import('./locales/pl.json'),
    'en': () => import('./locales/en.json'),
  },
});
